const rowPerPage = [5, 10, 15, 25, { text: 'All', value: -1 }]
export default rowPerPage